import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import ReactDOM from 'react-dom/client'
import ControllRoutes from './routes/routes-controller'
import { Provider } from './components/ui/provider'
import './style.css'
import '@fontsource/poppins'
import '@fontsource/figtree'
import '@fontsource/protest-revolution'
import { Provider as ProviderRedux } from 'react-redux'
import { store, persistor } from './store/store'
import { ToastContainer } from './components/elements/toast'
import { PersistGate } from 'redux-persist/integration/react'

ReactDOM.createRoot(document.getElementById('app')! as HTMLDivElement).render(
	<React.StrictMode>
		<ProviderRedux store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<Provider>
					<ToastContainer />
					<Router>
						<ControllRoutes />
					</Router>
				</Provider>
			</PersistGate>
		</ProviderRedux>
	</React.StrictMode>
)
